import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { GlCode } from "@/app/services/generated/glcodeService";
import { glCodeService } from "@/app/services/generated/glcodeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasGlCodesCache {
  glCodes: GlCodesCache;
}

// Singleton cache store
const glCodesCacheStore = new EntityCacheStore<GlCode>(
  EnumCacheEntityType.glCode,
  async () => glCodeService.getAllGlCodes()
);

// Ephemeral reader
export default class GlCodesCache extends EntityWithGuidKeyCache<GlCode> {
  constructor() {
    super(glCodesCacheStore, (x) => x.id);
  }
}
